import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { colors, fontFamily, radii } from '../../theme/tokens';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { Icon } from '../ui';
import LoginForm from './LoginForm';

// Login shown as a popup over the current page (same LoginForm as the /login page).
const LoginModal = ({ isOpen, onClose, stayOnPage = false }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isOpen) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Login"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      style={{
        position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(15,27,51,0.55)', display: 'flex',
        alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'center', overflowY: 'auto',
        padding: isMobile ? 16 : 24, boxSizing: 'border-box', fontFamily,
      }}
    >
      <div
        style={{
          position: 'relative', width: '100%', maxWidth: 480, boxSizing: 'border-box', background: colors.white,
          borderRadius: isMobile ? 22 : radii.hero, border: '1px solid ' + colors.border,
          boxShadow: '0 12px 40px rgba(15,27,51,0.25)', padding: isMobile ? '40px 20px 28px' : '48px 40px 40px',
        }}
      >
        <button
          type="button"
          aria-label="Close login"
          onClick={onClose}
          style={{
            position: 'absolute', top: 12, right: 12, width: 40, height: 40, borderRadius: 20, border: 0,
            background: 'transparent', color: colors.navy, cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center', padding: 0,
          }}
        >
          <Icon name="close" size={22} />
        </button>
        <LoginForm
          stayOnPage={stayOnPage}
          onLoginSuccess={() => (stayOnPage ? onClose() : navigate('/'))}
          onRegisterSuccess={() => navigate('/profile/complete')}
        />
      </div>
    </div>
  );
};

export default LoginModal;
